import {
  DirectoryActionConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import DirectoryApi from 'client/api/v2/DirectoryApi';

export const getCloudDirectoryDetailsOrCreateUrl = async (type) => {
  const filters = [{
    name: 'type',
    operator: 'eq',
    value: type,
  }];

  const { results: cloudDirectories } = await DirectoryApi
    .fetch(0, 100, undefined, undefined, undefined, filters);

  // redirect immediately to import
  // if only one directory is configured
  // for the specified type
  if (cloudDirectories.length === 1) {
    const directoryId = cloudDirectories[0].id;
    return `${ItemTypeRoutes[ItemTypeConsts.cloudDirectory]}/${type}/${directoryId}/${DirectoryActionConsts.import_users}`;
  }
  // default redirect
  return `${ItemTypeRoutes[ItemTypeConsts.cloudDirectory]}/${type}/${DirectoryActionConsts.create}`;
};

export default {
  getCloudDirectoryDetailsOrCreateUrl,
};
